/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Oauth2Inputs */

const cs_enum_oauth2 = /** @type {(inputs: Enum_Oauth2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

const en_enum_oauth2 = /** @type {(inputs: Enum_Oauth2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OAuth 2`)
};

/**
* | output |
* | --- |
* | "OAuth 2" |
*
* @param {Enum_Oauth2Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_oauth2 = /** @type {((inputs?: Enum_Oauth2Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Oauth2Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_oauth2(inputs)
	return cs_enum_oauth2(inputs)
});